export * from './sECOM.service';
import { SECOMService } from './sECOM.service';
export const APIS = [SECOMService];
